export function setScrollRestorationTarget(element) {
    // @ts-ignore
    window.__scrollrestorationtarget = element;
    if (element) {
        const scrollTo = element.scrollTo;
        element.scrollTo = (...args) => {
            element.__skipscrollrestoration = true;
            scrollTo.apply(element, args);
        }
    }
}

function getTarget(): HTMLElement {
    //@ts-ignore
    return window.__scrollrestorationtarget;
}

// Calculating width of browser's scrollbar
function getScrollbarWidth() {
    let outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";

    // @ts-ignore
    outer.style.msOverflowStyle = "scrollbar";

    document.body.appendChild(outer);

    let widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";

    // add innerdiv
    let inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    let widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode.removeChild(outer);

    return widthNoScroll - widthWithScroll;
}


if (window.history.pushState) {
    const SCROLL_RESTORATION_TIMEOUT_MS = 3000;
    const TRY_TO_SCROLL_INTERVAL_MS = 50;

    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    // Store current scroll position in current state when navigating away.
    window.history.pushState = function () {
        const target = getTarget();
        const newStateOfCurrentPage = Object.assign({}, window.history.state, {
            __scroll: {
                windowScrollX: window.scrollX,
                windowScrollY: window.scrollY,
                targetScrollX: target ? target.scrollLeft : 0,
                targetScrollY: target ? target.scrollTop : 0
            },
        });
        originalReplaceState.call(window.history, newStateOfCurrentPage, '');
        originalPushState.apply(window.history, arguments);
    };

    // Make sure we don't throw away scroll position when calling "replaceState".
    window.history.replaceState = function (state, ...otherArgs) {
        const newState = Object.assign({}, {
            __scroll: window.history.state?.__scroll,
        }, state);

        originalReplaceState.apply(window.history, [newState].concat(otherArgs));
    };

    let timeoutHandle = null;
    let scrollBarWidth = null;

    // Try to scroll to the scrollTarget, but only if we can actually scroll
    // there. Otherwise keep trying until we time out, then scroll as far as
    // we can.
    const tryToScrollTo = (state) => {
        const {windowScrollX, windowScrollY, targetScrollX, targetScrollY, latestTimeToTry} = state;

        // Stop any previous calls to "tryToScrollTo".
        clearTimeout(timeoutHandle);

        const target = getTarget();

        const body = document.body;
        const html = document.documentElement;
        if (!scrollBarWidth) {
            scrollBarWidth = getScrollbarWidth();
        }

        // From http://stackoverflow.com/a/1147768
        const documentWidth = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
        const documentHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

        if (documentWidth + scrollBarWidth - window.innerWidth >= windowScrollX &&
            documentHeight + scrollBarWidth - window.innerHeight >= windowScrollY || Date.now() > latestTimeToTry) {
            window.scrollTo(windowScrollX, windowScrollY);
            //@ts-ignore
            if (target && !target.__skipscrollrestoration) {
                target.scrollTo(targetScrollX, targetScrollY)
            }
        } else {
            timeoutHandle = setTimeout(() => tryToScrollTo(state), TRY_TO_SCROLL_INTERVAL_MS);
        }
    };

    // Try scrolling to the previous scroll position on popstate
    const onPopState = () => {
        const state = window.history.state;

        if (state?.__scroll) {
            setTimeout(() => tryToScrollTo({
                ...state.__scroll,
                latestTimeToTry: Date.now() + SCROLL_RESTORATION_TIMEOUT_MS,
            }));
        }
    };

    window.addEventListener('popstate', onPopState, true);
}